// Pomoćne funkcije za mjesečne sati

const HOURS_PER_WORKING_DAY = 8;

/**
 * Broj radnih dana (pon-pet) u mjesecu.
 * Ako tjedan prelazi između mjeseci, gledaju se samo dani koji su datuma u tom mjesecu.
 */
export function getWorkingDaysInMonth(year, month) {
  const daysInMonth = new Date(year, month, 0).getDate();
  let count = 0;
  for (let day = 1; day <= daysInMonth; day++) {
    const dayOfWeek = new Date(year, month - 1, day).getDay();
    // 0 = nedjelja, 1 = ponedjeljak, ..., 5 = petak, 6 = subota
    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      count++;
    }
  }
  return count;
}

/**
 * Redovni sati za mjesec = radni dani × 8 sati.
 * Isto za sve osobe.
 */
export function getRegularHoursForMonth(year, month) {
  const workingDays = getWorkingDaysInMonth(year, month);
  return workingDays * HOURS_PER_WORKING_DAY;
}

/**
 * Je li dan nedjelja?
 */
export function isSunday(year, month, day) {
  return new Date(year, month - 1, day).getDay() === 0;
}
